// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"8e583064","421":"ea873ee1","435":"1be937c5","879":"4285d960"}[chunkId] + ".chunk.css";
};